/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

/* file contains the settings used for the application */

export const ENCRYPTION_KEY = 'jWnZr4u7x!A%C*F-JaNdRgUkXp2s5v8y';

export const IMAGE_TYPES = 'image/gif, image/jpeg, image/png, image/bmp, image/tiff';

export const DATE_FORMAT = 'dd/MM/yyyy';

export const TIME_FORMAT = 'hh:mm';

export const DATETIME_FORMAT = 'dd/MM/yyyy, HH:mm';

export const SellWithUsLink = 'https://www.caringtransitions.com/two-ways-to-sell';

export const PayPalClientId = "ARkwxSGpqsZuIuN1j-adk3WqehA87ymk_SVI03FqNNs4cTd2UzU4bcL48EQHtO736VdnrPgax1amIfZX";

export const PAYPAL_SECRET = "EBF826pdWsE67GzBhHXB2kf-EHMNym6ddZVsvpncV8iQIDebTH3hwLYJ_WAuRWj0-Rf49LaL7BLT60d7";

export const PAYPAL_BASE_URL = "https://api.paypal.com";

export const PAYPAL_SANDBOX = false;

export const LOCATION_MILES = "100";

export const FEE_TYPE_LIST = [{
    name: "Packing",
    key: "packingamount"
}, {
    name: "Shipping",
    key: "shippinghandling"
}, {
    name: "Handling",
    key: "handling"
}, {
    name: "Delivery",
    key: "deliveryamount"
}, {
    name: "Additional Items Purchased",
    key: "additionalitem"
}, {
    name: "Additional Services or Fees",
    key: "additionalamount"
}, {
    name: "Tax",
    key: "taxamount"
}, {
    name: "Other",
    key: "otheramount"
}]

export const BID_AMOUNT = 5000;

export const CATERGORY = ["Ammo", "Firearms", "Gun Parts"];
//export const logRocketDevId = "va5ull/ctbidsdev";
export const PAYPAL_DESCRIPTION = 'Selecting Agree & Pay Now will charge/refund $1.01 on default payment method and be charged upon winning an item.';

export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.ctbids.buyer";

export const APP_STORE_URL = "https://apps.apple.com/us/app/ctbids/id6467594552";

export const NEWSANDSTORIESID = "68834324e87232dbd3958675";

export const ADSENSE = {
    ENABLE: true,
    HOME: {slotId: "6091273461"},
    FOOTER: {slotId: "5306162642"},
    ESTATE_SALE: {slotId: "3047664965"},
    LOCATION: {slotId: "8717436808"},
    ITEM_SEARCH: {slotId: "9425371051"},
    ITEM_VIEW: {slotId: "2679999304"},
    FAQ: {slotId: "2679999304"}
}
export const cookiesPolicy = 'https://image.ctbids.com/CTBidsCookiePolicy.pdf'
